import api from "../axiosInstance";

const BASE_URL = process.env.REACT_APP_API_URL + "/api/v1/email-schedule";

// Get all email schedules
export const getAllEmailSchedulesAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append("status", params.status);
    if (params.templateId) queryParams.append("templateId", params.templateId);
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);

    const response = await api.get(`${BASE_URL}?${queryParams.toString()}`);
    return response.data;
  } catch (e) {
    console.log("Error getting email schedules: " + e.message);
    throw e;
  }
};

// Get email schedule by ID
export const getEmailScheduleByIdAPI = async (id) => {
  try {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response.data;
  } catch (e) {
    console.log("Error getting email schedule: " + e.message);
    throw e;
  }
};

// Get schedules by template ID
export const getSchedulesByTemplateAPI = async (templateId) => {
  try {
    const response = await api.get(`${BASE_URL}/template/${templateId}`);
    return response.data;
  } catch (e) {
    console.log("Error getting schedules by template: " + e.message);
    throw e;
  }
};

// Create email schedule
export const createEmailScheduleAPI = async (payload) => {
  try {
    const response = await api.post(BASE_URL, payload);
    return response.data;
  } catch (e) {
    console.log("Error creating email schedule: " + e.message);
    throw e;
  }
};

// Update email schedule
export const updateEmailScheduleAPI = async (id, payload) => {
  try {
    const response = await api.put(`${BASE_URL}/${id}`, payload);
    return response.data;
  } catch (e) {
    console.log("Error updating email schedule: " + e.message);
    throw e;
  }
};

// Delete email schedule
export const deleteEmailScheduleAPI = async (id) => {
  try {
    const response = await api.delete(`${BASE_URL}/${id}`);
    return response.data;
  } catch (e) {
    console.log("Error deleting email schedule: " + e.message);
    throw e;
  }
};

// Pause email schedule
export const pauseEmailScheduleAPI = async (id) => {
  try {
    const response = await api.patch(`${BASE_URL}/${id}/pause`);
    return response.data;
  } catch (e) {
    console.log("Error pausing email schedule: " + e.message);
    throw e;
  }
};

// Resume email schedule
export const resumeEmailScheduleAPI = async (id) => {
  try {
    const response = await api.patch(`${BASE_URL}/${id}/resume`);
    return response.data;
  } catch (e) {
    console.log("Error resuming email schedule: " + e.message);
    throw e;
  }
};

// Get schedule statistics
export const getScheduleStatsAPI = async () => {
  try {
    const response = await api.get(`${BASE_URL}/stats`);
    return response.data;
  } catch (e) {
    console.log("Error getting schedule stats: " + e.message);
    throw e;
  }
};

// Preview audience for a schedule
export const previewAudienceAPI = async (payload) => {
  try {
    const response = await api.post(`${BASE_URL}/preview-audience`, payload);
    return response.data;
  } catch (e) {
    console.log("Error previewing audience: " + e.message);
    throw e;
  }
};

// Get users for schedule audience selection
export const getUsersForScheduleAPI = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append("search", params.search);
    if (params.page) queryParams.append("page", params.page);
    if (params.limit) queryParams.append("limit", params.limit);

    const response = await api.get(`${BASE_URL}/users?${queryParams.toString()}`);
    return response.data;
  } catch (e) {
    console.log("Error getting users for schedule: " + e.message);
    throw e;
  }
};
